import React, { useState } from 'react'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Divider,
  Typography,
  Button,
} from '@material-ui/core'
import { isNull } from 'lodash'

import * as service from 'service'
import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

const DialogDestroy = ({
  committeeId,
  committeeUserId = null,
  open,
  setOpen = () => {},
  onEvent = () => {},
}) => {
  const snackbar = useSnackbar()
  const [loading, setLoading] = useState(false)
  const isCommittee = isNull(committeeUserId)

  const destroy = async () => {
    setLoading(true)

    if (isCommittee) {
      try {
        await service.dponet.committees.destroy({ committeeId })
        snackbar.open({
          message: 'Comitê excluído com sucesso!',
          variant: 'success',
        })
        onEvent()
      } catch (error) {
        snackbar.open({
          message:
            helpers.formatters.errorMessage(error?.response?.data?.error) ||
            'Ocorreu um erro ao excluir o comitê.',
          variant: 'error',
        })
      } finally {
        setOpen(false)
        setLoading(false)
      }
    } else {
      try {
        await service.dponet.committeeUsers.destroy({
          committeeId,
          committeeUserId,
        })
        snackbar.open({
          message: 'Usuário removido do comitê com sucesso!',
          variant: 'success',
        })
        onEvent()
      } catch (error) {
        snackbar.open({
          message:
            helpers.formatters.errorMessage(error?.response?.data?.error) ||
            'Ocorreu um erro ao remover o usuário do comitê.',
          variant: 'error',
        })
      } finally {
        setOpen(false)
        setLoading(false)
      }
    }
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>
        <Box>
          <Typography variant="h4">Excluir comitê</Typography>
        </Box>
      </DialogTitle>
      <Divider />
      <Box mb={1}>
        <DialogContent>
          <Box>
            <Typography>
              Tem certeza que deseja{' '}
              {isCommittee ? 'excluir este ' : 'remover este usuário do '}
              comitê? Essa ação não pode ser desfeita.
            </Typography>
          </Box>
        </DialogContent>
      </Box>
      <Divider />
      <DialogActions p={2}>
        <Box pl={2} pr={1}>
          <Button
            disabled={loading}
            type="button"
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Cancelar
          </Button>
        </Box>
        <Button
          disabled={loading}
          variant="contained"
          type="submit"
          color="primary"
          onClick={destroy}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogDestroy
